import { render, staticRenderFns } from "./AddressProperties.vue?vue&type=template&id=5bd4e0e0&scoped=true"
import script from "./AddressProperties.vue?vue&type=script&lang=js"
export * from "./AddressProperties.vue?vue&type=script&lang=js"
import style0 from "./AddressProperties.vue?vue&type=style&index=0&id=5bd4e0e0&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4e0e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VContainer,VDivider,VList,VListItem,VListItemContent})
